import { useEffect, useState } from 'preact/hooks';
import { t } from '../i18n';

export type StepKey = keyof typeof t.steps;
export const STEP_ORDER: StepKey[] = ['find', 'dsm', 'horizon', 'irradiance', 'report'];

export function Progress({ title, step, frac }: { title: string; step: StepKey; frac: number }) {
  const cur = STEP_ORDER.indexOf(step);
  const [tip, setTip] = useState(0);
  useEffect(() => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const id = setInterval(() => setTip((k) => (k + 1) % t.progressTips.length), 4500);
    return () => clearInterval(id);
  }, []);
  return (
    <main id="main" class="wrap progress">
      <span class="eyebrow">{t.eyebrow}</span>
      <h1>{title}</h1>
      <ol class="steps" aria-live="polite">
        {STEP_ORDER.map((k, i) => (
          <li key={k} class={i < cur ? 'done' : i === cur ? 'active' : ''} aria-current={i === cur ? 'step' : undefined}>
            <span class="dot" aria-hidden="true" />
            <span class="lbl">{t.steps[k]}</span>
            {i === cur && (k === 'horizon' || k === 'irradiance') && <span class="pct num">{Math.round(frac * 100)} %</span>}
          </li>
        ))}
      </ol>
      <div class="pbar" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(((cur + frac) / STEP_ORDER.length) * 100)}>
        <span style={{ width: `${((cur + frac) / STEP_ORDER.length) * 100}%` }} />
      </div>
      <p class="cap">{t.progressNote}</p>
      <aside class="tip-card" aria-live="off">
        <span class="eyebrow">{t.progressTipsTitle}</span>
        <p key={tip}>{t.progressTips[tip]}</p>
      </aside>
    </main>
  );
}
